import React from 'react';
import {
  Datagrid,
  DateField,
  ReferenceManyField,
  TextField,
  usePermissions,
  useRecordContext,
} from 'react-admin';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
} from '@mui/material';

import hasAccess from '../../utilities/hasAccess';
import Pagination from '../layout/Pagination';
import NoResults from '../layout/NoResults';
import actions, { Actions } from '../../constants/actions';
import { listViewDatagridStyle } from '../../constants/style/datagridStyles';
import PermissionMissing from '../utils/PermissionMissing';
import resourceNames from '../../constants/resourceNames';

const RelatedIpAddresses = () => {
  const { permissions } = usePermissions<Actions[]>();
  const record = useRecordContext();

  if (!record) return null;

  return (
    <Card variant="outlined">
      <CardHeader title="IP addresses" />
      <Divider />
      <CardContent>
        { hasAccess(permissions, actions.IP_USAGE_LIST) ? (
          <ReferenceManyField
            reference={resourceNames.IP_USAGES}
            target="entityId"
            perPage={15}
            pagination={<Pagination disableEmptyText />}
          >
            <Datagrid sx={listViewDatagridStyle} bulkActionButtons={false} empty={<NoResults />}>
              <TextField sortable={false} source="ip" label="IP address" />
              <DateField sortable={false} source="firstTimeUsed" label="First time used" showTime />
              <DateField sortable={false} source="lastTimeUsed" label="Last time used" showTime />
            </Datagrid>
          </ReferenceManyField>
        ) : (
          <Box display="flex" alignItems="center" width="100%" flexDirection="column">
            <PermissionMissing />
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default RelatedIpAddresses;
